import React from 'react';
import './Grape.css';
import { useState, useEffect } from 'react';

const Grape = () => {

  const [isDirty] = useState(false);

  useEffect(() => {

    const onLocationChange = (e) => {
      if (isDirty) {
        document.dispatchEvent(new CustomEvent('modalx', { detail: e }));
      } else {
        document.dispatchEvent(new CustomEvent('navconfirmed', {detail: e}));
      }
    }

    document.addEventListener('popstateb', onLocationChange);

    return () => {
      document.removeEventListener('popstateb', onLocationChange);
    }
    
  }, [isDirty]);

  return (
    <div className='grapeComponent'>
      <div className='contentComponents'>
        Grape Component
      </div>
    </div>
  )
}

Grape.propTypes = {};

Grape.defaultProps = {};

export default Grape;
